import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const initialState = {
  isSuccess: false,
  reset: {
    step: 'token',
    token: null
  }
}

const ResetPasswordModule = {
  namespaced: true,
  state: initialState,
  actions: {
    resetPassword ({ commit, state, rootGetters }, { password, birthdate }) {
      const apolloClient = getProvider().defaultClient

      commit('clearMessages', {}, { root: true })

      return apolloClient.mutate({
        mutation: gql`mutation resetPasswordWithInfo ($input: ResetPasswordConfirmInput!){
          resetPasswordWithState (resetPasswordWithState: $input) {
            contractStatus
          }
        }`,
        variables: {
          input: {
            token: state.reset.token || 'empty',
            brand: rootGetters.brand,
            newPassword: password,
            birthdate: birthdate
          }
        }
      }).then((response) => {
        commit('setSuccess', true)
        commit('Transaction/removeTransactionId', 'resetPasswordConfirmation', { root: true })
        return response
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return error
      })
    }
  },
  mutations: {
    setSuccess (state, isSuccess) {
      state.isSuccess = isSuccess
    },
    resetSuccess (state) {
      state.isSuccess = false
    },
    captureToken (state, token, nextStep = 'password') {
      state.reset.token = token
      state.reset.step = nextStep
    },
    finalizeProcess (state, nextStep = 'success') {
      state.reset.token = null
      state.reset.step = nextStep
    },
    resetProcess: (state) => {
      state = initialState
    },
    setToken (state, token) {
      state.reset.token = token
    }
  },
  getters: {
    successState: state => state.isSuccess,
    step: state => state.reset.step,
    token: state => state.reset.token
  }
}

export {
  ResetPasswordModule
}
